// @flow

import { find, isEmpty } from 'lodash';

import type { AccountPlan } from '@zapier/design-system-revenue';

/*
   Handle very special case where legacy plan from old plan group is still hanging
   around, but it's not the current plan anymore - don't show it.
*/
export default (
  plans: Array<AccountPlan>,
  currentPlanId: number
): Array<AccountPlan> => {
  return plans.filter(plan => {
    if (!plan || isEmpty(plan)) {
      return false;
    }
    if (!plan.name.match(/legacy/i)) {
      return true;
    }
    return find(plan.intervals, i => i.id === currentPlanId);
  });
};
